<div class="shimmer" fxLayout="column" fxLayoutAlign="start stretch">
  <div class="thumbnail-circle"></div>
  <div fxFlex="60px"></div>
  <div class="loader-content" fxFlex="1 1" fxLayout="row" fxLayoutAlign="space-between stretch">
    <div class="bg-active" fxFlex="20px"></div>
    <div fxFlex="1 1" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="bg-active" fxFlex="20px"></div>
      <div fxFlex="10px" fxLayout="row" fxLayoutAlign="start stretch">
        <div fxFlex="0 0 70%"></div>
        <div class="bg-active" fxFlex="1 1"></div>
      </div>
      <div class="bg-active" fxFlex="10px"></div>
      <div fxFlex="10px"></div>
      <div class="bg-active" fxFlex="10px"></div>
      <div fxFlex="10px"></div>
      <div class="bg-active" fxFlex="1 1"></div>
    </div>
    <div class="bg-active" fxFlex="20px"></div>
  </div>
  <ng-content></ng-content>
</div>
